import {useSelector} from "react-redux";

export default function () {
    const addedResponseOption = useSelector(state => state.responseOptions.addedResponseOption);
    const loadingAddResponseOption = useSelector(state => state.responseOptions.loadingAddResponseOption);
    return { addedResponseOption, loadingAddResponseOption };
}